import React, { ReactNode, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { CloseButton, CloseButtonColor, CloseButtonSize } from '../LiliCloseButton/CloseButton';

interface IProps {
  children?: ReactNode;
  exitIcon?: boolean;
  contentWrapperClassName?: string;
  mainWrapperClassName?: string;
  onClick: (mode: boolean) => void;
  id: string;
  mainWrapperOverrideClassName?: string;
  contentWrapperOverrideClassName?: string;
  exitIconClassName?: string;
  shouldPersist?: boolean;
  shouldBlur?: boolean
}

export const UserMessage = ({
  children,
  onClick,
  contentWrapperClassName,
  mainWrapperClassName,
  id,
  exitIcon,
  mainWrapperOverrideClassName,
  contentWrapperOverrideClassName,
  exitIconClassName,
  shouldPersist,
  shouldBlur,
}: IProps) => {
  const screenStyle = `bg-bw07 flex justify-center fixed inset-0 h-screen w-screen bg-opacity-70 z-50 ${shouldBlur && 'backdrop-blur-sm'}`;
  const contentWrapperStyle = 'flex relative items-center justify-center w-fit';
  const handleClick = (e: any) => {
    e.preventDefault();
    if (shouldPersist) return;
    onClick(false);
  };
  useEffect(() => {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        onClick(false);
      }
    });
    return () => {
      document.removeEventListener('keydown', () => {});
    };
  }, []);
  return ReactDOM.createPortal(
    <div
      id={id}
      tabIndex={0}
      role='button'
      onKeyDown={() => {}}
      onClick={(e) => handleClick(e)}
      className={` ${mainWrapperOverrideClassName || screenStyle} ${mainWrapperClassName ?? 'items-center'} outline-none z-[99999] cursor-default`}
    >
      <div
        tabIndex={0}
        role='button'
        onKeyDown={() => {}}
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={`${contentWrapperOverrideClassName || contentWrapperStyle} ${contentWrapperClassName || ''} relative outline-none cursor-default`}
      >
        {exitIcon && (
          <CloseButton
            onClick={() => onClick(false)}
            id='closeButton'
            color={CloseButtonColor.Black}
            size={CloseButtonSize.Medium}
            className={exitIconClassName || 'absolute top-5 right-4 w-[0.625rem] h-[0.625rem] cursor-pointer z-10'}
          />
        )}
        {children && children}
      </div>
    </div>,
    document.getElementById('portal')!,
  );
};
